import { useMutation } from "src/Hooks/useReactQuery";
import { updateResourceTag } from "src/services/tags-service";

const useUpdateResourceTag = (options = {}) => {
  const { showAlert, t, onSuccess, onError, onSettled, ...restOptions } = options;

  return useMutation({
    mutationFn: ({ data }) => updateResourceTag({ data }),
    onSuccess: (data, payloadData) => {
      if (showAlert && t) {
        showAlert({
          status: true,
          message: t(payloadData?.data?.item_ids?.length > 1 ? "assign_tags_success" : "assign_tags_success_to_single_resource", {
            resourceLength: payloadData?.data?.item_ids?.length,
          }),
          type: "success",
        });
      }

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error) => {
      showAlert({
        status: true,
        message: t("assign_tags_failed"),
        type: "danger",
      });
      if (onError) {
        onError(error);
      }
    },
    onSettled: (data, error) => {
      if (onSettled) {
        onSettled(data, error);
      }
    },
    ...restOptions,
  });
};

export default useUpdateResourceTag;
